import { RoleBadge } from "../role-batch";

import type { ServiceUser, User } from "@sperrdatei/dto/types";
import type { JSX } from "react";

type UserListProps<T extends User | ServiceUser> = {
  caption: string;
  users: T[];
  disabled: boolean;
  addUser: () => void;
  removeUser: (user: T) => void;
  editUser: (user: T) => void;
};

export const UserList = <T extends User | ServiceUser>({
  caption,
  users,
  disabled,
  addUser,
  removeUser,
  editUser,
}: UserListProps<T>): JSX.Element | null => {
  return (
    <>
      <span className="form-text">{caption}</span>
      {
        <ul
          className="list-group"
          title={
            disabled ? "Sie müssen zuerst mindestens eine Domain erstellen" : ""
          }
        >
          {users.map((user) => (
            <button
              key={user.username + user.domain}
              className="list-group-item list-group-item-action d-flex"
              onClick={(e) => {
                e.preventDefault();
                editUser(user);
              }}
            >
              <div className="ms-2 me-auto">
                <div className="fw-bold small text-start">{`${user.username}@${user.domain}`}</div>
                {"roles" in user && (
                  <div className="badge-list text-start">
                    {user.roles.map((roleKey) => (
                      <RoleBadge key={roleKey} roleKey={roleKey} />
                    ))}
                  </div>
                )}
              </div>
              <i
                title="Benutzer löschen"
                className="bi bi-x-circle-fill ms-auto focus-alert"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  removeUser(user);
                }}
              />
            </button>
          ))}
          <button
            title="Benutzer hinzufügen"
            className="list-group-item list-group-item-action small"
            onClick={(e) => {
              e.preventDefault();
              addUser();
            }}
            disabled={disabled}
          >
            + Benutzer hinzufügen
          </button>
        </ul>
      }
    </>
  );
};
